import React from 'react'
import { Link } from 'gatsby'
import {
  Box, SxProps, Typography, useTheme 
} from '@mui/material'

type GradientBorderButtonProps = {
  link: string
  linkText: string
  externalLink?: boolean
  disableGradient?: boolean
  handleClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
  sx?: SxProps
  textSx?: SxProps
  borderSx?: object
}

export const GradientBorderButton = ({
  link,
  linkText,
  externalLink,
  disableGradient,
  handleClick,
  sx,
  textSx,
  borderSx
}: GradientBorderButtonProps) => {
  const { palette } = useTheme()

  return (
    <Box
      component={externalLink ? 'a' : Link}
      href={link}
      to={link}
      onClick={handleClick}
      sx={{ display: 'inline-block', ...sx }}>
      <Typography
        variant='subtitle2'
        sx={{
          color: 'background.default',
          px: 5,
          py: 2,
          position: 'relative',
          ...textSx,
          '&:before': {
            background: palette.background.gradient,
            borderRadius: 2,
            bottom: 0,
            content: '""',
            left: 0,
            p: 0.25,
            position: 'absolute',
            top: 0,
            right: 0,
            WebkitMaskComposite: disableGradient ? 'unset' : 'xor',
            WebkitMask:
              'linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0)',
            zIndex: -1,
            ...borderSx
          }
        }}>
        {linkText}
      </Typography>
    </Box>
  )
}
